import React, { memo } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { DefaultOutboundLink } from "./../../Miscellaneous/DefaultLink.component";

const AcademicPosition = (props) => {
  return (
    <div className="mb-3 mx-5">
      <Row className="">
        <Col xs={5}>
          <div className="text-white">
            <Row
              className="mx-auto"
              style={{
                borderBottom: "2px solid blue",
                backgroundColor: "rgb(0, 118, 212)",
              }}
            >
              <Col
                className="d-flex align-items-center justify-content-center flex-column p-2 font-open-sans fw-n"
                style={{ letterSpacing: "0.3ch" }}
              >
                {props.end_year}
              </Col>
            </Row>
            <Row
              className="mx-auto"
              style={{
                backgroundColor: "rgb(0, 81, 212)",
              }}
            >
              <Col
                className="d-flex align-items-center justify-content-center flex-column p-2 font-open-sans fw-n"
                style={{ letterSpacing: "0.3ch" }}
              >
                {props.start_year}
              </Col>
            </Row>
          </div>
          <div></div>
        </Col>
        <Col
          xs={7}
          className="d-flex align-items-start justify-content-center flex-column"
        >
          <div
            style={{
              fontSize: "1.25rem",
            }}
          >
            {props.position}
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column">
            <DefaultOutboundLink
              to={props.department_link}
              color={"rgba(0, 1, 238, 0.7)"}
            >
              {props.department}
            </DefaultOutboundLink>
            <DefaultOutboundLink
              to={props.university_link}
              color={"rgba(0, 16, 238, 0.7)"}
            >
              {props.university}
            </DefaultOutboundLink>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const startYearComparator = (a, b) => {
  try {
    const aStart = Number.parseInt(a?.start_year);
    const bStart = Number.parseInt(b?.start_year);
    return aStart - bStart;
  } catch (err) {
    return 0;
  }
};

const AcademicPositions = ({ positions }) => {
  return (
    <div className="w-100 p-5">
      <div className="w-80 mx-auto p-2 mb-2 border-bottom text-center">
        <h3 className="font-open-sans fw-l">Academic Positions</h3>
      </div>
      <div className="mt-5 mx-auto">
        {[...positions]
          .sort(startYearComparator)
          .reverse()
          .map((elem) => (
            <AcademicPosition key={elem.id} {...elem} />
          ))}
      </div>
    </div>
  );
};

export default memo(AcademicPositions);
